import { useState } from 'react';
import useFetch from 'use-http';

import { API_ROUTES } from '../../constants';
import { TAPIResponse } from '../../api.types';
import { TAPICreateDeveloperRequest, TAPICreateDeveloperResponse ,TAPIDeveloperRegistrationResponse} from './registration.types';


export type TAPIResponseCreateDeveloper = TAPIResponse & {
  data: Partial<TAPIDeveloperRegistrationResponse>;
  createDeveloper(body: TAPICreateDeveloperRequest): Promise<void>;
};

export const useAPICreateDeveloper = (): TAPIResponseCreateDeveloper => {
  const [responseData, setResponseData] = useState<Partial<TAPICreateDeveloperResponse>>({});
  const { post, response, loading, error } = useFetch(API_ROUTES.DEVELOPERS);

  async function createDeveloper(body: TAPICreateDeveloperRequest): Promise<void> {
    const createdDeveloper: TAPIDeveloperRegistrationResponse = await post(body);

    setResponseData(createdDeveloper);
  }

  return {
    loading,
    error,
    data: responseData,
    loaded: response.ok,
    createDeveloper,
  };
};
